import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { fetchProductList } from "../../api/Product_custom";
import { API_URL } from "env";
import { addItemToCart } from "api/Cart";
import RightQualityControl from "providers/QualityControlComponent/RightQualityControl";

interface ProductItem {
    id: number;
    name: string;
    slug: string;
    product_category_id: number;
    price: number;
    discount: number;
    avatar: string;
    is_active: number;
    is_highlight: number;
    short_content: string;
    position: number;
}

/* =======================
   COMPONENT
======================= */
export default function BclockProductPurchased() {
    const [products, setProducts] = useState<ProductItem[]>([])
    const [qtyMap, setQtyMap] = useState<Record<number, number>>({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [retryKey, setRetryKey] = useState(0)

    useEffect(() => {
        let mounted = true

        const getProducts = async () => {
            setLoading(true)
            setError(null)

            try {
                const res = await fetchProductList({ type: 2 })
                if (!mounted) return

                if (res.status && res.data?.items) {
                    setProducts(res.data.items)
                    const initialQty: Record<number, number> = {}
                    res.data.items.forEach((p: ProductItem) => {
                        initialQty[p.id] = 0
                    })
                    setQtyMap(initialQty)
                } else {
                    setProducts([])
                    setQtyMap({})
                }
            } catch (e: any) {
                if (!mounted) return
                setError(e?.message || "Không thể tải dữ liệu")
            } finally {
                if (!mounted) return
                setLoading(false)
            }
        }

        getProducts()
        return () => {
            mounted = false
        }
    }, [retryKey])

    const increase = async (id: number, name?: string) => {
        await addItemToCart(id.toString(), 1, true, name);
        setQtyMap(prev => ({
            ...prev,
            [id]: (prev[id] || 0) + 1,
        }))
    }

    const decrease = async (id: number, name?: string) => {
        await addItemToCart(id.toString(), -1, true, name);
        setQtyMap(prev => ({
            ...prev,
            [id]: Math.max(0, (prev[id] || 0) - 1),
        }))
    }

    const onChange = async (id: number, value: string, name?: string) => {
        const changeNumber = Number(value) - (qtyMap[id] || 0);
        await addItemToCart(id.toString(), changeNumber, true, name);
        const num = Number(value)
        if (!isNaN(num) && num >= 0) {
            setQtyMap(prev => ({ ...prev, [id]: num }))
        }
    }

    return (
        <div
            id="BLOCK_PRODUCT_HIGH_PROFIT"
            className="bg-white rounded-[10px] pt-4"
            style={{
                background:
                    "linear-gradient(90deg, rgb(209, 231, 191) 19%, rgb(209, 231, 191) 72%)",
            }}
        >
            {/* HEADER */}
            <div className="flex justify-between items-center px-4">
                <h2 className="font-bold text-gray-800 text-2xl flex items-center gap-2">
                    <img
                        src="https://cdn-gcs.thuocsi.vn/thuocsi-testing/internal/cms/2024077dad927087701225bc9aa634bchot-deal_1.svg"
                        style={{ width: 36 }}
                    />
                    <span>Top bán chạy</span>
                </h2>
            </div>

            <div className="flex flex-col gap-4 max-h-[700px] overflow-auto scrollbar-0 px-4 mt-2 pt-2 pb-4">
                {loading && (
                    <div className="text-center text-gray-600 py-4">Đang tải...</div>
                )}

                {!loading && error && (
                    <div className="flex flex-col items-center gap-2 py-4">
                        <div className="text-red-600">{error}</div>
                        <button
                            className="px-4 py-2 rounded bg-green-700 text-white"
                            onClick={() => setRetryKey(k => k + 1)}
                        >
                            Tải lại
                        </button>
                    </div>
                )}

                {!loading && !error && products.map(item => (
                    <div
                        key={item.id}
                        track-productitem=""
                        data-slug={item.slug}
                        data-href={`/product/${item.slug}`}
                        data-skucode={item.id}
                        data-blockcode="BLOCK_PRODUCT_HIGH_PROFIT"
                        className="flex flex-col w-full rounded-[10px] relative group border-[1px] transform transition-transform t-transition-transform duration-200
                        hover:scale-[1.05] hover:shadow-lg bg-white"
                    >
                        <div className="flex px-4 py-2">
                            <div className="min-w-[87px]">
                                <Link to={`/product/${item.slug}`}>
                                    <div className="relative w-[110px] h-[110px]">
                                        <img
                                            src={`${item.avatar?.startsWith('http') ? item.avatar : `${API_URL}/${item.avatar}`}?width=150&quality=80`}
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                </Link>
                            </div>

                            <div className="flex justify-between flex-1 sm:!flex-row !flex-col ml-4">
                                <div className="ml-2 font-[ggsm]">
                                    <h2 className="text-[16px] text-black line-clamp-3">
                                        {item.name}
                                    </h2>
                                </div>

                                <div className="flex flex-col items-end h-full justify-between">
                                    <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                        <div className="text-[22px] text-[#E3352C] !leading-[30px]">
                                            {item.price.toLocaleString("vi-VN")} ₫
                                        </div>
                                    </div>

                                    <div className="[&>div]:!bg-transparent">
                                        <RightQualityControl productId={item.id} productName={item.name} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
